const StoreActivity = () => import(/* webpackChunkName: "StoreActivity" */ '@/views/Shared/storeActivity')
const StoreTag = () => import('@/views/Shared/storeTag')
const SelectSample = () => import('@/views/Shared/selectSample')
const SelectStoreSd = () => import('@/views/Shared/selectStoreSd')
const SelectVisitPlan = () => import('@/views/Shared/selectVisitPlan')
const OrderUpdate = () => import('@/views/Shared/orderUpdate')
const ShelfStatus = () => import('@/views/Shared/shelfStatus')
const mappingRouter = [
  {
    path: '/shared/mappingActivity',
    component: StoreActivity,
    meta: {
      title: 'Mapping Activity'
    }
  },
  {
    path: '/shared/storeTag',
    component: StoreTag,
    meta: {
      title: 'Store Tag'
    }
  },
  {
    path: '/shared/selectSample',
    component: SelectSample,
    meta: {
      title: 'Sample Delivery'
    }
  },
  {
    path: '/shared/selectStoreSd',
    component: SelectStoreSd,
    meta: {
      title: ''
    }
  },
  {
    path: '/shared/selectVisitPlan',
    component: SelectVisitPlan,
    meta: {
      title: ''
    }
  },
  {
    path: '/shared/orderUpdate',
    component: OrderUpdate,
    meta: {
      title: 'Order Update'
    }
  },
  {
    path: '/shared/shelfStatus',
    component: ShelfStatus,
    meta: {
      title: 'Shelf Status'
    }
  }
]

export default mappingRouter
